import { Box, Stack, Typography } from '@mui/material';
import { colorTokens, typographyTokens } from '../app/designTokens';

const { semantic } = colorTokens;

/**
 * Shared App / TableToolbar composite (Default).
 */
export function TableToolbar({
  title,
  subtitle,
  meta,
  actions,
  mode = 'Default',
  sx,
}) {
  return (
    <Box
      data-table-toolbar-mode={mode}
      sx={{
        display: 'flex',
        alignItems: { xs: 'flex-start', sm: 'center' },
        justifyContent: 'space-between',
        gap: 2,
        flexWrap: 'wrap',
        px: 2.5,
        py: 2,
        bgcolor: semantic.bg.surface,
        borderBottom: `1px solid ${semantic.border.subtle}`,
        ...sx,
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Stack direction="row" spacing={1.5} alignItems="center" flexWrap="wrap" useFlexGap>
          {title && (
            <Typography
              sx={{
                fontFamily: typographyTokens.fontFamily,
                fontWeight: typographyTokens.fontWeightSemibold,
                fontSize: 14,
                lineHeight: '28px',
                color: semantic.text.primary,
              }}
            >
              {title}
            </Typography>
          )}
          {meta}
        </Stack>
        {subtitle && (
          <Typography sx={{ mt: 0.25, fontSize: 13, color: semantic.text.muted }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {actions && (
        <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap>
          {actions}
        </Stack>
      )}
    </Box>
  );
}
